import React from "react"

const Select = ({ options, value, onChange, className = "", containerClassName = "", error, showError = false, fullWidth = false, disabled = false }) => {
  return (
    <div className={`${fullWidth ? "w-full" : "inline-flex"} flex-col items-start ${containerClassName}`}>
      <select
        className={`editable-field mx-1 ${className}`}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
      >
        {options.map((option, index) => (
          <option key={index} value={option.toLowerCase()}>
            {option}
          </option>
        ))}
      </select>
      {showError && error && (
        <p className="text-red-500 text-sm mt-1">{error}</p>
      )}
    </div>
  )
}

export default Select;